// components/WalletTooltip.jsx
import { useState, useEffect, useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWallet, faList, faChartLine, faCreditCard, faReceipt, faMoneyBill, faExchangeAlt } from '@fortawesome/free-solid-svg-icons';
import React from 'react';
import { Translate } from 'react-localize-redux';
import { store } from '../..';
import useMobileSize from './hooks/useMobileSize';
import './assets/WalletTooltip.css'; // اضافه کردن فایل CSS
import { formatGram, formatPrice } from './utils/utils';

const WalletTooltip = () => {
  const [isOpen, setIsOpen] = useState(false);
  const tooltipRef = useRef(null);
  const iconRef = useRef(null);
  const state = store.getState();
  const isMobile = useMobileSize();
  const rialValue = state.cart.cart_credit;
  const toman = +rialValue / 10;
  const geramValue = state.cart.wallet_gearm_value;

  const toggleTooltip = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (tooltipRef.current && iconRef.current && !tooltipRef.current.contains(event.target) && !iconRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className='walletContainer'>
      {isMobile && <div className='walletSeparator'></div>}
      <div ref={iconRef} onClick={toggleTooltip} className={`walletIconContainer ${isOpen ? 'walletIconContainerActive' : ''}`}>
        <FontAwesomeIcon icon={faWallet} className='walletIcon' />
      </div>

      {isOpen && (
        <div ref={tooltipRef} className={`walletTooltip ${isMobile ? 'walletTooltipMobile' : 'walletTooltipDes'}`}>
          <div className={`walletTriangle ${isMobile ? 'walletTriangleMobile' : 'walletTriangleDes'}`}></div>
          <div className='walletOptionsContainer'>
            <div className='walletOption' style={{ justifyContent: 'space-between' }}>
              <div style={{ display: 'flex' }}>
                <div className='walletOptionIndicator walletOptionIndicatorGreen'></div>
                <div className='walletOptionContent'>
                  <div className='walletTitle'>
                    <Translate id='priceWallet' />
                  </div>
                  <div className='walletAmount'>
                    {' '}
                    {formatPrice(toman).replace('-', '')} تومان {formatPrice(toman).includes('-') ? 'بدهکار' : ''}
                  </div>
                </div>
              </div>

              <a
                href={'/transactions'}
                className='tahvilGold'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '15px',
                  opacity: 0.5,
                  cursor: 'pointer',
                  color: 'black',
                  marginTop: '20px',
                  fontSize: '12px',
                }}
              >
                لیست تراکنش ها
                <FontAwesomeIcon icon={faExchangeAlt} />
              </a>
            </div>
            <div className='walletOption'>
              <div className='walletOptionIndicator walletOptionIndicatorGreen'></div>
              <div className='walletOptionContent'>
                <div className='walletTitle'>
                  <Translate id='goldWallet' />
                </div>
                <div className='walletAmount'>{formatGram(+geramValue)} گرم</div>
              </div>
            </div>
          </div>

          <div className='walletButtonsContainer'>
            <a className='walletChargeButton' href='/profileInfo/wallet/'>
              <FontAwesomeIcon icon={faMoneyBill} className='walletButtonIcon' />
              <span className='walletButtonText'>شارژ کیف پول</span>
            </a>

            <a className='walletTransactionButton' href='/trading-details'>
              <FontAwesomeIcon icon={faList} className='walletButtonIcon' />
              <span className='walletButtonText'>
                <Translate id='tradingList' />
              </span>
            </a>

            <a className='walletGoldButton' href='/gold-trading'>
              <FontAwesomeIcon icon={faChartLine} className='walletButtonIcon' />
              <span className='walletButtonText'>
                <Translate id='tradeGold' />
              </span>
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default WalletTooltip;
